import { motion } from "framer-motion";
import { FileText, Search, Calculator, CheckCircle2, Package, Truck, ReceiptText, Headset, ArrowRight } from "lucide-react";
import { SectionHeading, EASE } from "./Reveal";

const steps = [
  { icon: FileText, name: "Solicitud" },
  { icon: Search, name: "Análisis de requerimiento" },
  { icon: Calculator, name: "Cotización" },
  { icon: CheckCircle2, name: "Aprobación" },
  { icon: Package, name: "Pedido" },
  { icon: Truck, name: "Entrega" },
  { icon: ReceiptText, name: "Facturación" },
  { icon: Headset, name: "Postventa" },
];

export default function Process() {
  return (
    <section id="proceso" className="relative py-24 md:py-36 bg-ecdeep overflow-hidden" data-testid="process-section">
      <div className="absolute -bottom-40 -left-32 h-[460px] w-[460px] rounded-full bg-ecamber/10 blur-[130px]" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <SectionHeading
          num="08"
          chapter="Nuestro Proceso"
          id="proceso"
          dark
          title={<>De la solicitud a la postventa, <span className="text-ecamber">sin fricciones</span></>}
          sub="Un flujo comercial claro y medible en ocho pasos."
        />
        <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-x-6 gap-y-14">
          {steps.map((s, i) => (
            <motion.div
              key={s.name}
              initial={{ opacity: 0, y: 36 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.09, ease: EASE }}
              className="relative flex flex-col items-start"
              data-testid={`process-step-${i}`}
            >
              <div className="flex items-center gap-3 w-full">
                <span className="relative inline-flex h-14 w-14 shrink-0 rounded-2xl bg-white/[0.06] border border-white/15 text-ecamber items-center justify-center">
                  <s.icon size={24} strokeWidth={1.9} />
                  <span className="absolute -top-2.5 -right-2.5 h-6 w-6 rounded-full bg-ecamber text-ecdeep text-[11px] font-bold flex items-center justify-center font-display">
                    {i + 1}
                  </span>
                </span>
                {i < steps.length - 1 && (
                  <span className="hidden md:flex flex-1 items-center text-white/20">
                    <span className="flex-1 h-px bg-gradient-to-r from-white/25 to-white/5" />
                    <ArrowRight size={14} className="ml-1 text-ecamber/60" />
                  </span>
                )}
              </div>
              <p className="mt-4 font-display text-sm md:text-base font-medium text-white leading-snug pr-4">{s.name}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
